import styled from 'styled-components';
import { NegativeFill } from 'ui/icons';
import { colors } from 'ui/theme';
import { useTranslations } from 'modules/templateEditor/hooks/useTranslations';

const HandlebarsMessageWrapper = styled.div`
  display: grid;
  grid-template-columns: 0fr 1fr;
  grid-gap: ${({ theme }) => theme.spacing.utils.pxToRem(6)};
`;

export const HandlebarsMessage = () => {
  const { t } = useTranslations();
  return (
    <HandlebarsMessageWrapper data-test="handlebars-restriction-text">
      <NegativeFill color={colors.textSecondary} />
      <span>{t('message.handlebarsRestrictionText')}</span>
    </HandlebarsMessageWrapper>
  );
};
